var content = require("!!../../../node_modules/css-loader/dist/cjs.js??ref--6-oneOf-5-1!../../../node_modules/postcss-loader/src/index.js??postcss!../../../node_modules/resolve-url-loader/index.js??ref--6-oneOf-5-3!../../../node_modules/sass-loader/lib/loader.js??ref--6-oneOf-5-4!./sidebar.scss");

if (typeof content === 'string') {
  content = [[module.id, content, '']];
}

var options = {}

options.insert = "head";
options.singleton = false;

var update = require("!../../../node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js")(content, options);

if (content.locals) {
  module.exports = content.locals;
}

if (module.hot) {
  if (!content.locals) {
    module.hot.accept(
      "!!../../../node_modules/css-loader/dist/cjs.js??ref--6-oneOf-5-1!../../../node_modules/postcss-loader/src/index.js??postcss!../../../node_modules/resolve-url-loader/index.js??ref--6-oneOf-5-3!../../../node_modules/sass-loader/lib/loader.js??ref--6-oneOf-5-4!./sidebar.scss",
      function () {
        var newContent = require("!!../../../node_modules/css-loader/dist/cjs.js??ref--6-oneOf-5-1!../../../node_modules/postcss-loader/src/index.js??postcss!../../../node_modules/resolve-url-loader/index.js??ref--6-oneOf-5-3!../../../node_modules/sass-loader/lib/loader.js??ref--6-oneOf-5-4!./sidebar.scss");

        if (typeof newContent === 'string') {
          newContent = [[module.id, newContent, '']];
        }
        
        update(newContent);
      }
    )
  }

  module.hot.dispose(function() { 
    update();
  });
}